import api from '@/api';

const initialState = {
    /*
        Включено ли отображение забоев на скважине: [wellId]: boolean
    */
    faceVisibleByWell: {},
    /*
        Информация о забоях для скважин: [wellId]: faceData
    */
    faceByWell: {},
    /*
        Отслеживает, был ли совершен запрос за забоями у конкретной скважины.
        Если был, повторных запросов не происходит.
    */
    faceStatusesByWell: {},
    isLoading: false,
};

export const faceWellModel = {
    name: 'faceWell',
    state: initialState,
    reducers: {
        setFaceVisibility(state, payload) {
            const { faceVisibleByWell } = state;
            const { wellId, isVisible } = payload;

            const updatedFaceVisibleByWell = { ...faceVisibleByWell, [wellId]: isVisible };

            return { ...state, faceVisibleByWell: updatedFaceVisibleByWell };
        },
        setMeta(state, wellId) {
            const { faceStatusesByWell } = state;

            return { ...state, faceStatusesByWell: { ...faceStatusesByWell, [wellId]: { isCalled: true } } };
        },
        setIsloading(state, payload) {
            return { ...state, isLoading: payload };
        },
        setResponseFaceData(state, payload) {
            const { faceByWell } = state;
            const { wellId, result } = payload;

            const updatedFaceByWell = { ...faceByWell, [wellId]: result };

            return { ...state, faceByWell: updatedFaceByWell };
        },
    },
    effects: {
        /*
            Процесс инициализации состояния faceVisibleByWell.
        */
        init(wellId, rootState) {
            const { faceVisibleByWell } = rootState.faceWell;

            if (wellId in faceVisibleByWell) return;

            this.setFaceVisibility({ wellId, isVisible: false });
        },
        /*
            Запрос выполняется чрезвычайно долго. Причина: сложный запрос к БД.
        */
        async getFaceWell(wellId, rootState) {
            this.setIsloading(true);
            const { faceByWell, faceStatusesByWell } = rootState.faceWell;

            if (wellId in faceByWell) return;

            if (wellId in faceStatusesByWell && faceStatusesByWell[wellId].isCalled) return;

            this.setMeta(wellId);

            try {
                const response = await api.carottage.fetchFaces({ wellId: [wellId] });
                const result = response.bottomholesByWell || [];
                this.setResponseFaceData({ wellId, result });
                this.setIsloading(false);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log('Error in getting data on the faces', wellId, error);
                this.setResponseFaceData({ wellId, result: [] });
            }
        },
    },
};
